import { makeStyles } from "@material-ui/core";
import React from "react";

import { FONT_MED } from "../../styles/fonts";

interface SectionCardMultiValueProps {
  items: React.ReactNode[];
  separator?: string | null;
  className?: string;
  dataTestId?: string;
}

function isRenderable(item: React.ReactNode): boolean {
  if (item === null || item === undefined) return false;
  if (typeof item === "string" && item.trim() === "") return false;
  return true;
}

export default function SectionCardMultiValue({
  items,
  separator = ",",
  className = "",
  dataTestId,
}: SectionCardMultiValueProps) {
  const classes = useStyles();
  const filtered = items.filter(isRenderable);
  if (filtered.length === 0) return null;
  return (
    <span className={`${classes.root} ${className}`} data-testid={dataTestId}>
      {filtered.map((item, idx) => {
        const isLast = idx === filtered.length - 1;
        const trailing = !isLast && separator ? separator : "";
        return (
          <span key={idx} className={classes.item}>
            {typeof item === "string" ? (
              `${item}${trailing}`
            ) : (
              <>
                {item}
                {trailing}
              </>
            )}
          </span>
        );
      })}
    </span>
  );
}

const useStyles = makeStyles(() => ({
  root: {
    display: "inline-flex",
    flexWrap: "wrap",
    gap: "4px 8px",
  },
  item: {
    fontSize: 14,
    lineHeight: "18px",
    ...FONT_MED,
  },
}));
